/*
 * Copyright © 2025. Legalbird eine Marke der Legalbird GmbH
 */

import abstractCaseTranslations from "./abstractCaseTranslations";
import abstractLitigationCaseTranslations from "./abstractLitigationCaseTranslations";
import bankDataTranslations from "./bankDataTranslations";

const generalCivilLawTranslations = {
  ...abstractCaseTranslations,
  ...abstractLitigationCaseTranslations,
  finalClientDescriptionAndObjectives: {
    label: "Beschreibung der Situation",
  },
  isDamageQuantifiable: {
    label: "Lässt sich die Höhe der gewünschten Zahlung / des entstandenen Schadens genau beziffern?",
    options: {
      yes: {
        label: "Ja, der Schaden lässt sich beziffern",
      },
      no: {
        label: "Nein, der Schaden lässt sich nicht beziffern",
      },
      true: {
        label: "Ja, der Schaden lässt sich beziffern",
      },
      false: {
        label: "Nein, der Schaden lässt sich nicht beziffern",
      },
    },
  },
  objectivesClient: {
    label: "Zielsetzungen",
    options: {
      payment: {
        label: "Zahlung",
      },
      injunction: {
        label: "Unterlassung",
      },
      removal: {
        label: "Beseitigung",
      },
      handover: {
        label: "Herausgabe",
      },
      other: {
        label: "Etwas anderes",
      },
    },
  },
  incidentDate: {
    question: "Wann war der (erste) Vorfall? Wenn Sie den Tag nicht genau benennen können, geben Sie einfach ein ungefähres Datum ein.",
    label: "Datum des Vorfalls",
  },
  incidentFrequency: {
    question: "Ist der Vorfall mehrfach vorgekommen oder handelt es sich um ein einmaliges Ereignis?",
    label: "Anzahl der Ereignisse",
    options: {
      once: {
        label: "Es handelt sich um ein einmaliges Ereignis",
      },
      multiple: {
        label: "Es ist bereits mehrfach vorgekommen",
      },
    },
  },
  hasPreciseIncidentAddress: {
    question: "Können Sie eine genaue Adresse benennen, an der es zu dem Vorfall kam?",
    options: {
      yes: { label: "Ja, ich kann Straße und Ort benennen" },
      no: { label: "Nein, der Ort verfügt über keine eindeutige Adresse" },
    },
  },
  incidentLocalityDescription: {
    question: "Bitte beschreiben Sie den Ort des Vorfalls",
    label: "Beschreibung des Vorfallortes",
    helperText: "Beschreiben Sie bitte möglichst genau, wo sich der Vorfall ereignet hat, z. B. “Im Park “Stadtgarten” in Köln.”",
  },
  incidentAddress: {
    streetAddress: {
      label: "Straße und Hausnummer Unfallort",
    },
    postalCode: {
      label: "PLZ Unfallort",
    },
    addressLocality: {
      label: "Ort Unfallort",
    },
  },
  clientBankData: {
    ...bankDataTranslations,
  },
};

export default generalCivilLawTranslations;
